module.exports = __webpack_public_path__ + "img/icon_collect2.1fb8955a.svg";